import { List, ListAllDependency, ListVariant } from 'src/api';
import { useStore } from 'src/context';
import { isObject } from '../utils';

/**
 * Use Dependency List Answers
 */
const useDependencyListAnswersAll = <T extends ListVariant | List>(
  list: T[] = [],
  all: ListAllDependency
) => {
  const { results } = useStore();

  return list.filter(listItem => {
    if (!all) {
      return true;
    }

    const { groups, type } = all;

    return groups.map(el =>
      el.conditions.map(cond => {
        const { questionId, answers } = cond;

        const currentResult = results[questionId];
        if (Array.isArray(currentResult)) {
          const answerList = cond.answers.split('|');
          return currentResult.some(current =>
            answerList.includes(String(current))
          );
        }

        if (isObject(currentResult)) {
          const currentResult_k = Object.keys(currentResult);

          return answers
            .split('|')
            .some(answer =>
              currentResult_k.some(current => current === answer)
            );
        }

        if (!isObject(currentResult) && !Array.isArray(currentResult)) {
          return currentResult === answers;
        }
      })
    );
  });
};

export { useDependencyListAnswersAll };
